import ProtectedMenuItemLink from "../ProtectedMenuItemLink";
import school from "../../../pages/schools";
import student from "../../../pages/students";
import parent from "../../../pages/parents";
import SubMenu from "../SubMenu";
import dueRenewalStudents from "../../../pages/dueRenewalStudents";
import changeRequestForms from "../../../pages/changeRequestForms";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../Menu";
import SectionComponent from "../SectionComponent";

interface SchoolsAndStudentsMenuProps {
  permissions: string[];
}

const SchoolsAndStudentsMenu: FC<SchoolsAndStudentsMenuProps> = ({
  permissions,
}) => {
  const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);

  const availableResources = [
    "schools",
    "students",
    "parents",
    "studentRenewals",
    "ccaStudentRenewals",
    "changeRequestForms",
    "parentsWithoutStudent",
  ];

  if (permissions.length === 0) {
    return <></>;
  }

  // Give specific show menu access based on resource
  const findResources = permissions.filter((permission) =>
    availableResources.includes(permission),
  );
  if (findResources.length === 0) {
    return <></>;
  }

  return (
    <SectionComponent name={open ? "Schools & Students" : "S & S"}>
      <ProtectedMenuItemLink
        to={`/schools`}
        primaryText={"Schools Management"}
        leftIcon={<school.icon />}
        permissions={permissions}
        permissionResource="schools"
      />
      <ProtectedMenuItemLink
        to={`/students`}
        primaryText={"Students Management"}
        leftIcon={<student.icon />}
        permissions={permissions}
        permissionResource="students"
      />
      <ProtectedMenuItemLink
        to={`/parents`}
        primaryText={"Parents Management"}
        leftIcon={<parent.icon />}
        permissions={permissions}
        permissionResource="parents"
      />
      <SubMenu
        name="Student Renewals"
        icon={<dueRenewalStudents.icon />}
        permissions={permissions}
        permissionResources={["studentRenewals", "ccaStudentRenewals"]}
      >
        <ProtectedMenuItemLink
          to={`/studentRenewals`}
          primaryText={"Regular"}
          leftIcon={<dueRenewalStudents.icon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="studentRenewals"
        />
        <ProtectedMenuItemLink
          to={`/ccaStudentRenewals`}
          primaryText={"CCA"}
          leftIcon={<dueRenewalStudents.icon />}
          style={{ whiteSpace: "normal" }}
          permissions={permissions}
          permissionResource="ccaStudentRenewals"
        />
      </SubMenu>
      <ProtectedMenuItemLink
        to={`/changeRequestForms`}
        primaryText={"Change Request"}
        leftIcon={<changeRequestForms.icon />}
        permissions={permissions}
        permissionResource="changeRequestForms"
      />
      <ProtectedMenuItemLink
        to={`/parentsWithoutStudent`}
        primaryText={"Parents Without Student"}
        leftIcon={<parent.icon />}
        style={{ whiteSpace: "normal" }}
        permissions={permissions}
        permissionResource="parentsWithoutStudent"
      />
    </SectionComponent>
  );
};

export default SchoolsAndStudentsMenu;
